export const REPORT_COLUMN_CATALOG = [
  // Core
  {
    key: "lead_id",
    label: "Lead_ID",
    viewKey: "leadId",
    group: "Core",
  },
  { key: "company", label: "Dealership", viewKey: "dealership", group: "Core" },
  { key: "email", label: "Dealership Email", viewKey: "email", group: "Core" },
  {
    key: "main_line",
    label: "Dealership Main Line",
    viewKey: "mainLine",
    group: "Core",
  },
  {
    key: "website",
    label: "Dealership Website",
    viewKey: "website",
    group: "Core",
  },
  {
    key: "street_address",
    label: "Dealership Street Address",
    viewKey: "streetAddress",
    group: "Core",
  },
  {
    key: "city",
    label: "Dealership City",
    viewKey: "city",
    group: "Core",
  },
  {
    key: "state",
    label: "Dealership State",
    viewKey: "state",
    group: "Core",
  },
  {
    key: "zip_code",
    label: "Dealership ZIP",
    viewKey: "zipCode",
    group: "Core",
  },
  {
    key: "country",
    label: "Dealership Country",
    viewKey: "country",
    group: "Core",
  },

  // Classification
  {
    key: "status",
    label: "Status",
    viewKey: "status",
    group: "Classification",
  },
  {
    key: "service_dashboard",
    label: "Service Dashboard",
    viewKey: "serviceDashboard",
    group: "Classification",
  },
  {
    key: "manufacturer",
    label: "Manufacturers",
    viewKey: "manufacturer",
    group: "Classification",
  },
  {
    key: "rooftops",
    label: "# of Rooftops",
    viewKey: "rooftops",
    group: "Classification",
  },

  {
    key: "lead_type",
    label: "Lead Type",
    viewKey: "leadType",
    group: "Classification",
  },
  {
    key: "lead_source",
    label: "Lead Source",
    viewKey: "leadSource",
    group: "Classification",
  },
  {
    key: "dealer_group",
    label: "Dealer Group",
    viewKey: "dealerGroup",
    group: "Classification",
  },
  {
    key: "opportunity_yn",
    label: "Opportunity Y/N",
    viewKey: "opportunity",
    group: "Classification",
  },

  // Arrays
  {
    key: "dms_providers",
    label: "DMS Providers",
    viewKey: "dms",
    group: "Arrays",
  },
  { key: "products", label: "Products", viewKey: "products", group: "Arrays" },
  {
    key: "other_dms_provider",
    label: "Other DMS Provider",
    viewKey: "otherDmsProvider",
    group: "Classification",
  },

  // Dates
  {
    key: "contact_date",
    label: "Contact Date",
    viewKey: "contactDate",
    group: "Dates",
  },
  { key: "demo_status", label: "Demo Status", viewKey: "demo", group: "Dates" },
  {
    key: "created_at",
    label: "Created Date",
    viewKey: "created",
    group: "Dates",
  },
  {
    key: "updated_at",
    label: "Updated Date",
    viewKey: "updated",
    group: "Dates",
  },
  {
    key: "demo_date",
    label: "Demo Scheduled Date",
    viewKey: "demoDate",
    group: "Dates",
  },
  {
    key: "demo_time",
    label: "Demo Scheduled Time",
    viewKey: "demoTime",
    group: "Dates",
  },
  {
    key: "demo_timezone",
    label: "Demo Timezone",
    viewKey: "demoTimezone",
    group: "Dates",
  },

  // Activity
  {
    key: "activity",
    label: "Activity",
    viewKey: "activity",
    group: "Activity",
  },
  {
    key: "last_contact",
    label: "Activity Date",
    viewKey: "lastContact",
    group: "Activity",
  },
  {
    key: "next_contact",
    label: "Next Activity Date",
    viewKey: "nextContact",
    group: "Dates",
  },
  {
    key: "activity_notes",
    label: "Activity Notes",
    viewKey: "activityNotes",
    group: "Activity",
  },
  {
    key: "next_activity",
    label: "Next Activity",
    viewKey: "nextActivity",
    group: "Activity",
  },
  {
    key: "next_activity_notes",
    label: "Next Activity Notes",
    viewKey: "nextActivityNotes",
    group: "Activity",
  },

  // Ownership
  {
    key: "partner_name",
    label: "Sales Representative",
    viewKey: "salesRep",
    group: "Ownership",
  },

  // Contact
  {
    key: "contact_first_name",
    label: "Contact First Name",
    viewKey: "contactFirstName",
    group: "Contact",
  },
  {
    key: "contact_last_name",
    label: "Contact Last Name",
    viewKey: "contactLastName",
    group: "Contact",
  },
  {
    key: "contact_email",
    label: "Contact Email",
    viewKey: "contactEmail",
    group: "Contact",
  },
  {
    key: "contact_job_title",
    label: "Contact Job Title",
    viewKey: "contactJobTitle",
    group: "Contact",
  },
  {
    key: "contact_home_phone",
    label: "Contact Home Phone",
    viewKey: "contactHomePhone",
    group: "Contact",
  },
  {
    key: "contact_work_phone",
    label: "Contact Work Phone",
    viewKey: "contactWorkPhone",
    group: "Contact",
  },
  {
    key: "contact_mobile_phone",
    label: "Contact Mobile Phone",
    viewKey: "contactMobilePhone",
    group: "Contact",
  },

  // Notes
  {
    key: "next_steps",
    label: "Next Steps",
    viewKey: "nextSteps",
    group: "Notes",
  },
  { key: "notes", label: "Notes", viewKey: "notes", group: "Notes" },
];

export const TEMPLATE_COLUMNS = REPORT_COLUMN_CATALOG.filter(
  (c) => c.viewKey !== null,
);

export const TEMPLATE_SORT_KEYS = [
  { key: "dealership", label: "Dealership" },
  { key: "status", label: "Status" },
  { key: "lead_source", label: "Lead Source" },
  { key: "lead_type", label: "Lead Type" },
  { key: "sales_rep", label: "Sales Rep" },
  { key: "contact", label: "Contact First Name" },
  { key: "next_contact_date", label: "Next Activity Date" },
  { key: "demo_date", label: "Demo" },
  { key: "created", label: "Created" },
  { key: "updated", label: "Updated" },
  { key: "last_activity", label: "Last Activity" },
];

export const VIEW_KEY_BY_REPORT_KEY = (() => {
  const m = {};
  for (const c of REPORT_COLUMN_CATALOG) {
    if (c.viewKey) m[c.key] = c.viewKey;
  }
  return m;
})();
